import { HttpClient } from '@angular/common/http';
import { effect, inject, Injectable } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop'
import { map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BranchService } from '../branch/branch.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class Branches {

  private apiURL: string = environment.apiURL
  private brancheEndPoint: string = environment.brancheEndPoint
  private http = inject(HttpClient)
  private branchService = inject(BranchService)
  protected router = inject( Router );

  branchesRessource = rxResource({
    loader: () => this.http.get<Branch[]>(`${this.apiURL + this.brancheEndPoint}`)
    .pipe(
      map(brancheResponse => brancheResponse )
    )
  })

  eff = effect( () => {
    if (!this.branchesRessource.isLoading())
      this.branchService.fetchBranches.set(this.branchesRessource.value()!)

    if(this.branchesRessource.error() !== undefined) {
      this.router.navigate([`/information/`, 'server'], {queryParamsHandling: 'merge', replaceUrl: true})
    }
  })

}
